import ProjectListV2 from '@containers/project/ProjectListV2';

const ProjectListPageV2 = () => {
  return <ProjectListV2 />
};

export default ProjectListPageV2;
